import React, { useState, useContext } from 'react';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { IAgentQAGroupedItem } from 'types/agentQA';
import AgentQAItemsModel from 'models/AgentQAItemsModel';
import ModuleContext from 'CMFW/context/ModuleContext';

const AgentQARetryRenderer: React.FC<ICellRendererParams> = (params) => {
  const data = params.data as IAgentQAGroupedItem | undefined;
  const itemsModel = useContext(ModuleContext) as AgentQAItemsModel;
  const [isRetrying, setIsRetrying] = useState(false);

  if (!data) return null;

  // Only show retry when all runs are complete (pending_count === 0)
  const isComplete = data.pending_count === 0;

  if (!isComplete) {
    return null;
  }

  const handleRetry = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isRetrying) return;

    setIsRetrying(true);
    try {
      await itemsModel.retryItem(data.entity_key);
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <RetryContainer>
      <RetryButton onClick={handleRetry} disabled={isRetrying} title="Retry this item">
        <FontAwesomeIcon icon={isRetrying ? faSpinner : faRedo} spin={isRetrying} />
      </RetryButton>
    </RetryContainer>
  );
};

export default AgentQARetryRenderer;

const RetryContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const RetryButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #1976d2;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: #e3f2fd;
    color: #1565c0;
  }

  &:disabled {
    cursor: wait;
    color: #90caf9;
  }
`;
